import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import {
  useWorkflowsByTrigger,
  type UseWorkflowsByTriggerResult,
} from 'src/graphql/entities/workflow/hooks/use-workflows-by-trigger';

/**
 * The emergency override card's workflow list: the platform partner's, grouped by trigger.
 * Binds two decisions the card must not get wrong — an override may only force a *platform*
 * workflow, and unrunnable ones are shown rather than hidden. Assignments need both owners and
 * call `useWorkflowsByTrigger` directly.
 */
export function usePlatformWorkflowsByTrigger(): UseWorkflowsByTriggerResult {
  // Shown disabled with the reason: silently missing reads as "it does not exist".
  return useWorkflowsByTrigger(PLATFORM_PARTNER_ID, {
    includeWithoutActiveVersion: true,
  });
}
